function initAnnouncementSlider(mautoPlay, cycleSpeed) {
  const existingSwiper = document.querySelector('.M-announcement-slider').swiper;
  if (existingSwiper) {
    existingSwiper.destroy(true, true);
  }
  new Swiper(".M-announcement-slider", {
    spaceBetween: 30,
    effect: "fade",
    loop: true,
    autoplay: mautoPlay ? {
      delay: cycleSpeed,
      disableOnInteraction: false,
    } : false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}